import React from 'react'

const ApproveIconBlack = () => {
    return (
        <svg width="7" height="31" viewBox="0 0 7 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.07804 22.4254C1.37793 22.4254 0 21.0478 0 19.3474V3.07804C0 1.37822 1.37822 0 3.07804 0C4.77757 0 6.15608 1.37822 6.15608 3.07804V19.3474C6.15638 21.0478 4.77816 22.4254 3.07804 22.4254Z" fill="black" />
            <path d="M2.88051 30.9993C4.33762 30.9993 5.51883 29.8181 5.51883 28.361C5.51883 26.9039 4.33762 25.7227 2.88051 25.7227C1.4234 25.7227 0.242188 26.9039 0.242188 28.361C0.242188 29.8181 1.4234 30.9993 2.88051 30.9993Z" fill="black" />
        </svg>
    )
}

export default ApproveIconBlack
